import { render, staticRenderFns } from "./FullscreenTabs.vue?vue&type=template&id=561cfd80&scoped=true"
import script from "./FullscreenTabs.vue?vue&type=script&lang=js"
export * from "./FullscreenTabs.vue?vue&type=script&lang=js"
import style0 from "./FullscreenTabs.vue?vue&type=style&index=0&id=561cfd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561cfd80",
  null
  
)

export default component.exports